// removed by extract-text-webpack-plugin
module.exports = {"container":"ssmnbhGo-vMFVlEs4vdgS","header":"_2kSwCzDQYKFZnfHQvGzgWu","searchContainer":"Ei8EHsdzxLxHAmfkEIpSW","addContainer":"_1bMVf7bpmSAVRxAlY2ytU5","addBtn":"_1YPDjQ8RopC_458p59i52Q","bodyContainer":"_6U4KQ_CX4FR-8-bT5aed9","nameContainer":"_2Bq5j8BQcDfeFMCczlAuSv","name":"_3dooi22TTrmaUbAucJZuhE","tagList":"_2jibng1EIL4XzbV-e8YWP6","roleList":"_2konDtmZ1ZMqTQuj2DxTB9","roleItem":"_2QHX_DmdpS052weBn_s2GG","tagItem":"_1Qt8mEUrqpPbcWVy8bDP40"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Users/style/Users.pcss
// module id = 1356
// module chunks = 0